import isBnInViewport from './ad-refresh'

function debounce(delay, fn) {
  let inDebounce = null
  return function (args) {
    clearTimeout(inDebounce)
    inDebounce = setTimeout(function () {
      fn(args)
    }, delay)
  }
}

export const LAYOUT_UPDATE_EVENT_NAME = 'fc-layout-update'
export const LAYOUT_UPDATE_EVENT_TARGET = 'document'
function fcLayoutUpdate() {
  window[LAYOUT_UPDATE_EVENT_TARGET].dispatchEvent(new CustomEvent(LAYOUT_UPDATE_EVENT_NAME))
}

const googleTagEvents = ['slotOnload', 'slotRenderEnded']
function fcLayoutUpdateDispatcher(service) {
  const debounced = debounce(200, fcLayoutUpdate)
  googleTagEvents.forEach(eventName =>
    service.addEventListener(eventName, debounced)
  )
}

export default function initFcAds(el) {
  window.googletag = window.googletag || {}
  window.googletag.cmd = window.googletag.cmd || []
  window.FCAds = window.FCAds || { BNSlots: [], BNQueue: [], cmd: [] };
  // BNSlots: to be able to populate banner definitions before fc-ads is asynchronously loaded
  // BNQueue: to be able to call banner displays before fc-ads is asynchronously loaded
  const BNSlotsDebug = window.location.href.indexOf('bnslotsdebug=1') !== -1
  debug('FCAds 1.7.9 loading')
  const { FCAds, googletag } = window

  debug(googletag)
  googletag.cmd.push(() => fcLayoutUpdateDispatcher(googletag.pubads()))

  function debug(msg) {
    if (!BNSlotsDebug) return

    const message = (typeof msg === 'function') ? msg.call() : msg
    const messageWithTimestamp = `${message} at +${(performance.now() - window.FCAds.FCAdsInitTime).toFixed(1)}ms`
    console.log(messageWithTimestamp) // eslint-disable-line no-console
  }

  function defineBannerSlot(slotDef) {
    debug(`BNSlot ${slotDef.id} defining, ${slotDef.code}`)
    let mapping = googletag.sizeMapping()
    slotDef.mapping.forEach(m => {
      mapping = mapping.addSize(...m)
    })
    let definition = googletag
      .defineSlot(slotDef.code, slotDef.defaultSize, slotDef.id)
    if (slotDef.targeting) {
      slotDef.targeting.forEach(([targetingKey, targetingValue]) => {
        definition = definition.setTargeting(targetingKey, targetingValue)
      })
    }
    definition
      .defineSizeMapping(mapping.build())
      .addService(googletag.pubads())
  }

  function getSlotDefById(slotId) {
    return window.FCAds.BNSlots.find(slotDef => slotDef.id === slotId)
  }

  function unpackNoRefreshFor(no_refresh_for) {
    let unpacked = {}
    for (let [category, keys] of Object.entries(no_refresh_for)) {
      unpacked[category] = keys.reduce((acc, el) => { acc[el] = true; return acc }, {})
    }
    return unpacked
  }

  function displayBanner(slotId) {
    const slotDef = FCAds.BNSlots.find(def => def.id === slotId)
    if (!slotDef) return

    if (slotDef.delayed) {
      defineBannerSlot(slotDef)
      slotDef.delayed = false
    }
    debug(`BNSlot ${slotId}: displaying`)

    let placeholderDisplayed = false
    let bannerClosedByUser = false
    let timesBannerRefreshed = 0
    let afterRenderTimer = null
    let afterViewTimerElapsed = false
    let afterRenderTimerElapsed = false
    const { refreshOpts, stickyFooter, adPlaceholders } = slotDef

    if (refreshOpts) {
      const refresher = slot => {
        debug(`BNSlot ${slotId}: refreshing`)
        timesBannerRefreshed += 1
        afterRenderTimerElapsed = false
        afterViewTimerElapsed = false
        googletag.cmd.push(() => googletag.pubads().refresh([slot]))
      }

      const checkRefreshVisible = (slot, element) => {
        if (isBnInViewport(element)) {
          refresher(slot)
        } else {
          // debug(`BNSlot ${element.id}: out of the viewport, waiting`);
          setTimeout(() => checkRefreshVisible(slot, element), 1000)
        }
      }

      const checkRefresh = slot => {
        if (afterRenderTimerElapsed && afterViewTimerElapsed) {
          debug(`BNSlot ${slotId}: ready for refresh`)

          if (timesBannerRefreshed >= refreshOpts.maxTimes) {
            debug(`BNSlot ${slotId}: reached the refresh limit`)
          } else if (stickyFooter) {
            if (bannerClosedByUser) {
              debug(`BNSlot ${slotId}: closed by user`)
            } else {
              refresher(slot)
            }
          } else {
            checkRefreshVisible(slot, document.getElementById(slotId))
          }
        }
      }

      afterRenderTimer = slot => {
        debug(`BNSlot ${slot.getSlotElementId()}: after-render elapsed`)
        afterRenderTimerElapsed = true
        checkRefresh(slot)
      }

      const afterViewTimer = slot => {
        debug(
          `BNSlot ${slot.getSlotElementId()}: viewed and after-view timer elapsed`
        )
        afterViewTimerElapsed = true
        checkRefresh(slot)
      }

      googletag.pubads().addEventListener('impressionViewable', event => {
        if (event.slot.getSlotElementId() === slotId) {
          setTimeout(() => afterViewTimer(event.slot), refreshOpts.viewedDelay)
        }
      })
    }

    if (refreshOpts || stickyFooter || adPlaceholders) {
      googletag.pubads().addEventListener('slotRenderEnded', event => {
        if (event.slot.getSlotElementId() === slotId) {
          if (event.isEmpty) {
            debug(() => `BNSlot ${slotId}: render ended, ${getSlotDefById(slotId).code}, empty result`)
          } else {
            debug(() => `BNSlot ${slotId}: render ended, ${getSlotDefById(slotId).code}, non-empty`)

            if (stickyFooter) {
              const a = document.getElementById(slotId)
              if (!placeholderDisplayed) {
                a.style.backgroundColor = 'rgba(237, 237, 237, 0.82)'
                a.style.position = 'fixed'
                a.style.bottom = '0px'
                a.style.padding = '4px 0 0 0'
                a.style.zIndex = '9999'
                a.style.width = '100%'
                a.style.textAlign = 'center'
                a.style.transform = 'translate(-50%, 0%)'
                a.style.left = '50%'
                a.style.display = ''
                placeholderDisplayed = true
              }
              const i = document.createElement('img')
              i.id = 'close-button'
              i.src =
                'data:image/svg+xml;utf8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNzQuMjM5IDE3NC4yMzkiPjxnIGZpbGw9IiM2YjZiNmIiPjxwYXRoIGQ9Ik04Ny4xMiAwQzM5LjA4MiAwIDAgMzkuMDgyIDAgODcuMTJzMzkuMDgyIDg3LjEyIDg3LjEyIDg3LjEyIDg3LjEyLTM5LjA4MiA4Ny4xMi04Ny4xMlMxMzUuMTU3IDAgODcuMTIgMHptMCAxNTkuMzA1Yy0zOS44MDIgMC03Mi4xODUtMzIuMzgzLTcyLjE4NS03Mi4xODVTNDcuMzE4IDE0LjkzNSA4Ny4xMiAxNC45MzVzNzIuMTg1IDMyLjM4MyA3Mi4xODUgNzIuMTg1LTMyLjM4NCA3Mi4xODUtNzIuMTg1IDcyLjE4NXoiLz48cGF0aCBkPSJNMTIwLjgzIDUzLjQxNGMtMi45MTctMi45MTctNy42NDctMi45MTctMTAuNTU5IDBMODcuMTIgNzYuNTY4IDYzLjk2OSA1My40MTRjLTIuOTE3LTIuOTE3LTcuNjQyLTIuOTE3LTEwLjU1OSAwcy0yLjkxNyA3LjY0MiAwIDEwLjU1OWwyMy4xNTEgMjMuMTUzLTIzLjE1MiAyMy4xNTRhNy40NjQgNy40NjQgMCAwIDAgMCAxMC41NTkgNy40NDUgNy40NDUgMCAwIDAgNS4yOCAyLjE4OCA3LjQzNyA3LjQzNyAwIDAgMCA1LjI4LTIuMTg4TDg3LjEyIDk3LjY4NmwyMy4xNTEgMjMuMTUzYTcuNDQ1IDcuNDQ1IDAgMCAwIDUuMjggMi4xODggNy40NDIgNy40NDIgMCAwIDAgNS4yOC0yLjE4OCA3LjQ2NCA3LjQ2NCAwIDAgMCAwLTEwLjU1OUw5Ny42NzkgODcuMTI3bDIzLjE1MS0yMy4xNTNhNy40NjUgNy40NjUgMCAwIDAgMC0xMC41NnoiLz48L2c+PC9zdmc+'
              i.style.position = 'absolute'
              i.style.top = '-12px'
              i.style.right = '3px'
              i.style.width = '24px'
              i.style.height = '24px'
              i.onclick = () => {
                a.style.display = 'none'
                bannerClosedByUser = true
              }
              a.appendChild(i)
            }

            if (refreshOpts) {
              if (FCAds.config.no_refresh_for && !FCAds.config.unpacked_no_refresh_for) {
                FCAds.config.unpacked_no_refresh_for = unpackNoRefreshFor(FCAds.config.no_refresh_for);
              }
              if ((event.campaignId && FCAds.config.unpacked_no_refresh_for && FCAds.config.unpacked_no_refresh_for.campaigns && FCAds.config.unpacked_no_refresh_for.campaigns[event.campaignId]) ||
              (event.lineItemId && FCAds.config.unpacked_no_refresh_for && FCAds.config.unpacked_no_refresh_for.line_items && FCAds.config.unpacked_no_refresh_for.line_items[event.lineItemId])) {
                // forbidden to refresh
              } else {
                setTimeout(
                    () => afterRenderTimer(event.slot),
                    refreshOpts.renderedDelay
                )
              }
            }

            if (adPlaceholders && !stickyFooter) {
              const a = document.getElementById(slotId)
              a.classList.remove('bn-placeholder-visual')
            }
          }
        }
      })
    }

    googletag.display(slotId)
  }

  function displayBannerWithGoogletag(slotId) {
    googletag.cmd.push(() => displayBanner(slotId))
  }

  function defineBannerSlotWithGoogletag(slotDef) {
    debug(`defineBannerSlotWithGoogletag('${slotDef.id}') called`)
    if (!slotDef.delayed) googletag.cmd.push(() => defineBannerSlot(slotDef))
  }

  function executeCodeImmediately(command) {
    debug(`Executing immediately: ${command.toString()}`)
    command()
  }

  debug('FCAds slot definition queue starts')
  FCAds.BNSlots.forEach(slotDef => defineBannerSlotWithGoogletag(slotDef))
  debug('FCAds slot definition queue ends')
  FCAds.BNSlots.push = (val) => {
    debug(`Defining slot immediately: ${val}`)
    defineBannerSlotWithGoogletag(val)
  }

  debug('FCAds cmd queue execution starts')
  FCAds.cmd.forEach(command => {
    debug(`Executing from cmd array: ${command.toString()}`)
    command()
  })
  FCAds.cmd.push = executeCodeImmediately
  debug('FCAds cmd queue execution end')

  // googletag.display() calls should happen AFTER googletag.enableServices(), so this call is at the end
  // otherwise no error is reported by GPT, but the slots remain empty
  FCAds.BNQueue.forEach(slotId => displayBannerWithGoogletag(slotId))
  FCAds.BNQueue.push = displayBannerWithGoogletag

  debug('FCAds loaded')
}
